<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <filter-manager
          v-model="searchModel.filters"
          ref="reportFilterRed"
          :filters="filterManagerConfig"
          @search="this.downloadReport"
          items-container-class="flex-wrap"
          :display-advanced="false"
          class="search-bar"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process"
          :is-advanced="false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import DocumentServices from "@/modules/report/document";
import ReportServices from "@/modules/report/api";


export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Resumen de Servicio Mixto por Proveedor',
      routes: ["Inicio","Reportes","Reportes","Resumen de Servicio Mixto por Proveedor"]
    },
       searchModel: {
      collections: {
        academicYears: [],
      },
      filters: {
        academicYear: null,
      },
    },
  }),
computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYears',
          component: 'CustomDropDown',
          options: this.searchModel.collections.academicYears,
          value: this.searchModel.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          label: 'Año Académico',
          placeholder: 'Seleccione',    
          fieldName: 'name',
          fieldKey: 'id',
          validations: 'required',
          error: 'El campo Año Académico es obligatorio.',
        },
      ]
    },
  },
    async mounted() {
    this.FiltroFacturasSometidas();
  },
  methods: {
    async FiltroFacturasSometidas() {
      await AcademicYearServices.getInvoiceYears()
      .then(res => this.searchModel.collections.academicYears = res.data);
    }, 
    async downloadReport() {
      await ReportServices.getReport("mixedservicebilling", {
        academicYearId: this.searchModel.filters.academicYear.id
        }).then ((res) => DocumentServices.Download(res.data))  
    },
    onChangeAcademicYear(value) {
      this.searchModel.filters.academicYear = value
    },
  },
}
</script>